import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

/**
 * Bottone compatto per cambiare lingua tra IT e EN.
 * La preferenza viene salvata in localStorage (chiave `ah_lang`) da i18next-browser-languagedetector.
 */
export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.language || "it").startsWith("it") ? "it" : "en";

  function toggle() {
    i18n.changeLanguage(current === "it" ? "en" : "it");
  }

  return (
    <button
      type="button"
      onClick={toggle}
      className="inline-flex items-center gap-1.5 px-2 py-1 rounded-sm hover:bg-cream2 transition-colors text-[10px] tracking-[0.18em] uppercase text-slate1"
      title={current === "it" ? "Switch to English" : "Passa all'italiano"}
      data-testid="language-switcher"
      data-current-lang={current}
    >
      <Globe size={12} />
      <span className={current === "it" ? "text-ink font-medium" : "text-slate1"}>IT</span>
      <span className="text-slate1/40">/</span>
      <span className={current === "en" ? "text-ink font-medium" : "text-slate1"}>EN</span>
    </button>
  );
}
